/* eslint-disable vue/valid-v-slot */

import alert from '@/plugins/alert'
import { TeacherExam } from '@/plugins/api'
/* eslint-disable no-unused-vars */

export default {
  namespaced: true,
  state: {
    count: 0,
    teachers: [],
    teacherSearchParams: {},
    pageText: '',
    loading: false,
  },
  actions: {
    async fetchTeacherExams({ commit }, options) {
      return await TeacherExam.fetch({ ...options })
    },
    async fetchTeacherExam({ commit }, id) {
      return await TeacherExam.fetchOne(id)
    },
    async createTeacherExam({ commit }, data) {
      return await TeacherExam.create(data)
    },
    async updateTeacherExam({ commit }, { id, ...data }) {
      return await TeacherExam.update(id, { ...data })
    },
    async countTeacherExams({ commit }, options) {
      return await TeacherExam.count(options)
    },
    async removeTeacherExam({ commit }, id) {
      await TeacherExam.remove(id)
      alert.success('Bỏ giáo viên ra khỏi kỳ thi thành công')
    },
  },
}
